export default {
      id: "oc-navbar-more-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-navbar-more",
      toString: function () {
        return this.url;
      }
    }